<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Advanced Settings</h3>
		</header>
		<div class="card-body">
			<section>
				<h4 class="card-subtitle">Revisions</h4>
				<div class="input-group">
					<select id="revision" v-model="selectedRevisionId">
						<option disabled value="null">Select a revision</option>
						<option :value="revision.revision_id" v-for="revision in editorAdvanced.revisions">{{ revision.updated_at }}</option>
					</select>
					<a @click.prevent="loadRevision()" class="btn btn-primary" href="#">Load</a>
				</div>
			</section>
			<section>
				<h4 class="card-subtitle">Article Actions</h4>
				<div class="action-links">
					<a @click.prevent="archiveArticle" href="#" v-if="userRoles.includes('articles.editor')">Archive Article</a>
					<a @click.prevent="deleteArticle" class="text-danger" href="#" v-if="userRoles.includes('articles.delete')">Delete Article</a>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import {eventBus} from "../../app";

	export default {
		props: {
			editorAdvanced: {
				required: true
			}
		},
		data() {
			return {
				selectedRevisionId: null,
				userRoles: this.$currentUserRoles
			}
		},
		methods: {
			loadRevision: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				/* Listening in ArticleEditor */
				eventBus.$emit('onLoadRevision', vm.selectedRevisionId);
			},
			archiveArticle: function () {
				let vm = this;
				if (vm.editorAdvanced.id) {
					eventBus.$emit('onLoaderStart');
					axios.put('/api/' + vm.$selectedSite.slug + '/articles/' + vm.editorAdvanced.id + '/archive')
							.then(function () {
								eventBus.$emit('onLoaderFinish');
								vm.$toastr.success('Article archived.');
							})
							.catch(function (e) {
								eventBus.$emit('onLoaderFinish');
								vm.errors.record(e.response.data);
								vm.$toastr.error('Article archiving failed.', 'Error');
							});
				}
			},
			deleteArticle: function () {
				let vm = this;

				eventBus.$emit('onLoaderStart');
				vm.$dialog.confirm('Are you sure you want to delete this article?', {
					loader: true
				}).then(function (dialog) {
					axios.delete('/api/' + vm.$selectedSite.slug + '/articles/' + vm.editorAdvanced.id)
							.then(function () {
								eventBus.$emit('onLoaderFinish');
								dialog.close();
								window.onbeforeunload = null;
								window.location.replace(process.env.MIX_APP_URL + vm.$selectedSite.slug + '/articles');
							})
							.catch(function () {
								eventBus.$emit('onLoaderFinish');
								dialog.close();
								vm.$toastr.error('Article delete failed.', 'Error');
							});
				});
			},
		}
	}
</script>

<style scoped>

</style>
